import {styled} from '@packages/utilities/styled';

export const InputAddon = styled('div')(
  ({theme}) => ({
    ...theme.typography.finePrint,
    alignItems: 'center',
    color: theme.colors.foregroundDim,
    display: 'flex',
    lineHeight: `${theme.typography.finePrint}px`,
  }),
  {
    prefix: {
      alignItems: 'center',
      borderBottomLeftRadius: 0,
      borderTopLeftRadius: 0,
      cursor: 'default',
      display: 'flex',
      overflow: 'hidden',
      paddingLeft: 4,
      paddingRight: 4,
    },
  }
);
